import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=PRO_PRICING_EXP:control
// ?preferred_variant=PRO_PRICING_EXP:variant_1
// ?remove_preferred_experiment=PRO_PRICING_EXP

export const ProPricingExpName = 'PRO_PRICING_EXP' as const;

export type ProPricingExpVariants = ToVariants<typeof ProPricingExpVariants>;

export const ProPricingExpVariants = {
	/** Control: 2.49€ per month (same as prod currently) */
	CONTROL: 'control',
	/** V1: change price to €3.99 per month */
	VARIANT_1: 'variant_1',
} as const;

export default generate(ProPricingExpName, ProPricingExpVariants);
